import apiConfig from '../../config/api_config';

export const messageApi = {
    newConversation: (data) => apiConfig.post('/conversations/', data),
    getConversations: (param) => apiConfig.get('/conversations/', param),
    newMessage: (data) => apiConfig.post(`/messages/`, data),
    getMessages: (params) => apiConfig.get(`/messages/?chat_id=${params.chat_id}`, params),
    updateConversation: (id,data) => apiConfig.put(`/conversations/${id}`, data),
    deleteConversation: (id) => apiConfig.delete(`/conversations/${id}`),

};